import React from 'react'

import OptimizedImage from './OptimizedImage'

export default function Sidebar({ latestPosts = [] }) {
  return (
    <div className="col s12 l4 left-align sidebar">
      <ul className="collection with-header m-t-3">
        <li className="collection-header">
          <h5>Latest Posts</h5>
        </li>
        {latestPosts.map(
          ({
            node: { id, excerpt, frontmatter: { title, featuredImage, path } },
          }) => (
            <li className="collection-item avatar" key={id}>
              <a href={path}>
                <div style={{ position: 'absolute', left: 0 }}>
                  <OptimizedImage
                    image={featuredImage}
                    defaultImage="http://placehold.it/42x42"
                    alt=""
                    className="circle"
                    type="resolutions"
                  />
                </div>
                <span className="title">{title}</span>
                <p>{excerpt}</p>
              </a>
            </li>
          )
        )}
      </ul>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Sidebar.js